import { PaginationResponse } from '@app/components/ui/paginator/paginator';
import RubberTable from '@app/components/rubber-table';
import { Paginator } from '@ui';
import React from 'react';
import AliasForOperator from '@app/pages/settings/blocks/common-settings/alias_for_operator';
import { TableFilter } from '@app/components/table/table.type';

export const QmUsersTableBlock = (props: {
  currentPaginationData: PaginationResponse;
  handleChangePage({ offset, limit }: PaginationResponse): void;
  onFilter?(filter: TableFilter): void;
  total: number;
  tableData;
  tableColumns;
}) => {
  const { currentPaginationData, onFilter, handleChangePage, total, tableData, tableColumns } =
    props;
  return (
    <div className="flex flex-col gap-[20px]">
      <div className="flex flex-col gap-[20px]">
        <RubberTable onFilter={onFilter} columns={tableColumns} dataSource={tableData || []} />
        <Paginator
          page={Math.ceil(currentPaginationData?.offset + 1)}
          count={total}
          onChange={handleChangePage}
          limit={currentPaginationData?.limit}
          withRerender
        />
      </div>
      <div>
        <AliasForOperator />
      </div>
    </div>
  );
};
